import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createSwpTransaction,
  deleteSwpTransactionApi,
  getSwpStats,
  updateSwpTransactionApi,
} from "../../api/transaction";
import { useInvalidateTransactionOrder } from "./transaction";

export const useCreateSwpTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/swp/create"],
    mutationFn: createSwpTransaction,
    onSuccess: invalidate,
  });
};

export const useDeleteSwpTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/swp/delete"],
    mutationFn: deleteSwpTransactionApi,
    onSuccess: invalidate,
  });
};

export const useUpdateSwpTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/swp/update"],
    mutationFn: updateSwpTransactionApi,
    onSuccess: invalidate,
  });
};

export const useSwpStats = (investmentAccountId: string, enabled = true) => {
  return useQuery({
    queryKey: ["swp-stats", investmentAccountId],
    queryFn: () => getSwpStats(investmentAccountId),
    enabled,
  });
};
